import * as React from 'react';

import { Dispatch } from 'redux';
import { useLocation } from 'react-router';
import { connect, useSelector } from 'react-redux';

import styled from 'styled-components';

import { ContactInfo } from '@webapp/types/common/contact-info';

import AppState from '@webapp/store/state';
import { VerifyAccount } from '@webapp/store/auth/action-creators';
import {
  VERIFY_ACCOUNT,
  VERIFY_ACCOUNT_ERROR,
} from '@webapp/store/auth/actions';
import AccountVerificationData from '@webapp/types/auth/account-verification-data';

import { Translate } from 'react-localize-redux';

import Flex from '@components/layout/flex';
import Grid from '@components/basics/grid';
import InputField from '@components/form/input';
import ButtonArrow from '@components/actions/arrow-button';

import EmailOrPhoneCtrl from '@webapp/controllers/form/email-or-phone';

import { getAccountName } from '@services/user/lib/get-account-name';

interface VerifyAccountCtrlProps {
  account: string | null;
  className?: string;
  loading: boolean;
  verifyAccount: (data: AccountVerificationData) => VerifyAccount;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  verifyAccount: (data: AccountVerificationData) =>
    dispatch(new VerifyAccount(data)),
});

const mapStateToProps = (state: AppState) => ({
  loading: !!state.ui.loading[VERIFY_ACCOUNT],
});

export const WrapperInputs = styled.div`
  display: block;
`;

export const VerifyAccountCtrl: React.FC<VerifyAccountCtrlProps> = (props) => {
  const [contact, setContact] = React.useState<ContactInfo>();

  const urlParams = new URLSearchParams(useLocation().search);
  const verificationCode = urlParams.get('code');

  const [code, setCode] = React.useState(verificationCode || '');

  const codeError = useSelector(
    (state: AppState) => !!state.ui.errors[VERIFY_ACCOUNT_ERROR]
  );

  return (
    <form
      autoComplete="off"
      className={props.className}
      onSubmit={(ev) => {
        ev.preventDefault();
        if (!code) {
          return;
        }

        let account = props.account;

        if (!account) {
          if (!contact) {
            return;
          }

          account = getAccountName(contact.value);
        }

        props.verifyAccount({ account, code });
        setCode('');
      }}
    >
      <Flex>
        <Flex
          className="wrapper"
          justifyContent="space-between"
          alignItems="center"
          gap={10}
        >
          <Grid className="container" gap={5}>
            {!props.account ? (
              <EmailOrPhoneCtrl
                isGrey
                value={contact?.value}
                onChange={(value) => setContact(value)}
              />
            ) : null}
            <InputField
              name="code"
              autoComplete="off"
              value={code}
              isGrey
              label="Verification Code"
              error={
                codeError ? <Translate id="CodeMismatchException" /> : undefined
              }
              onChange={(value) => setCode(value)}
            />
          </Grid>
          <ButtonArrow
            type="submit"
            disabled={code === ''}
            id="verifyAccount"
            className="button-arrow"
            isLoading={!!props.loading}
          />
        </Flex>
      </Flex>
    </form>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(VerifyAccountCtrl)`
  .wrapper {
    width: 100%;
  }
  .container {
    flex-grow: 1;
  }
  .button-arrow {
    max-width: 78px;
  }
`);
